import React from 'react'
import { observer } from 'mobx-react-lite'

import {
  CurrencyInput,
  ListItemAction,
  useAccountStore,
  useGlobalCopyStore,
  useEvent,
  ANALYTICS_EVENTS,
} from '../../../common'
import { DebtChartData } from '../../../core/utils/DebtUtils'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

interface MonthlyPaymentActionProps {
  debt: DebtChartData
}

export const MonthlyPaymentAction = observer(({ debt }: MonthlyPaymentActionProps) => {
  const { debts: copy } = useGlobalCopyStore()
  const { updateAccount } = useAccountStore()
  const { onEvent } = useEvent()

  const [payment, setPayment] = React.useState<number>(debt.monthly_payment ?? 0)
  const isInvalid = payment < 0 || payment > 99999999.99

  const handleSave = async () => {
    await updateAccount({ ...debt.account, minimum_payment: payment })
    debt.monthly_payment = payment
    onEvent(ANALYTICS_EVENTS.DEBTS_SAVE_PAYMENT_ACTION, { account_guid: debt.guid })
  }

  const handleCancel = () => {
    setTimeout(() => {
      setPayment(debt.monthly_payment ?? 0)
    }, 250)
  }

  return (
    <ListItemAction
      isSaveDisabled={isInvalid}
      label={copy.details_monthly_payment}
      onCancel={handleCancel}
      onSave={handleSave}
      primaryText={copy.details_monthly_payment}
      secondaryText={formatCurrency(debt.monthly_payment, '0,0')}
      zeroStateText={!debt.monthly_payment ? copy.add_monthly_payment : undefined}
    >
      <CurrencyInput
        amount={payment}
        autoFocus={true}
        error={isInvalid}
        fullWidth={true}
        minAmount={0}
        setAmount={(v) => setPayment(!isNaN(Number(v)) ? Number(v) : payment)}
        sx={{ '.MuiTypography-body1': { p: 0 } }}
      />
    </ListItemAction>
  )
})
